export const TIPOS_FREQUENCIA_RECORRENCIA = [
  { value: 'MENSAL', label: 'Mensal' },
  { value: 'DATA_ESPECIFICA', label: 'Data específica' },
  { value: 'DIAS_SEMANA', label: 'Dias da semana' },
  { value: 'DIAS_MES', label: 'Dias do mês' },
]

export const PERIODICIDADE_POR_TIPO = {
  MENSAL: [
    { value: 'MENSAL', label: 'Todo mês (mensal)' },
    { value: 'BIMESTRAL', label: 'A cada 2 meses' },
    { value: 'TRIMESTRAL', label: 'A cada 3 meses' },
    { value: 'SEMESTRAL', label: 'A cada 6 meses' },
    { value: 'ANUAL', label: 'Todo ano (anual)' },
  ],
  DATA_ESPECIFICA: [
    { value: 'DATA_FIXA', label: 'Na data informada' },
  ],
  DIAS_SEMANA: [
    { value: 'SEMANAL', label: 'Semanalmente' },
    { value: 'QUINZENAL', label: 'A cada 15 dias' },
  ],
  DIAS_MES: [
    { value: 'DIA_FIXO_MES', label: 'Em dia fixo do mês' },
  ],
}

export const DIA_VENCIMENTO_OPCOES = [
  { value: 'MESMO_DIA_COMPETENCIA', label: 'Mesmo dia da competência' },
  { value: 'PRIMEIRO_DIA_MES', label: '1º dia do mês' },
  { value: 'ULTIMO_DIA_MES', label: 'Último dia do mês' },
  { value: 'DIA_5', label: 'Dia 5' },
  { value: 'DIA_10', label: 'Dia 10' },
  { value: 'DIA_15', label: 'Dia 15' },
]

export const TERMINO_OPCOES = [
  { value: 'POR_OCORRENCIAS', label: 'Por número de ocorrências' },
  { value: 'ATE_DATA', label: 'Até uma data' },
  { value: 'SEM_TERMINO', label: 'Sem término (indefinido)' },
]

export const DIAS_MES_OPCOES = [
  ...Array.from({ length: 31 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1),
  })),
  { value: 'ULTIMO', label: 'Último' },
]

export const REPETIR_ANUALMENTE_OPCOES = [
  { value: 'NAO', label: 'Não — repetir todo mês neste dia' },
  { value: 'SIM', label: 'Sim — repetir todo ano nesta data' },
]

export const DIAS_SEMANA_OPCOES = [
  { value: 'DOM', label: 'Dom' },
  { value: 'SEG', label: 'Seg' },
  { value: 'TER', label: 'Ter' },
  { value: 'QUA', label: 'Qua' },
  { value: 'QUI', label: 'Qui' },
  { value: 'SEX', label: 'Sex' },
  { value: 'SAB', label: 'Sáb' },
]

function parseDataApi(value) {
  if (value == null || value === '') return null
  const d = value instanceof Date ? value : new Date(`${String(value).slice(0, 10)}T12:00:00`)
  return Number.isNaN(d.getTime()) ? null : d
}

/** Converte dia de vencimento legado da API em data para o calendário. */
export function diaVencimentoApiParaData(rec, ref = new Date()) {
  const base =
    ref instanceof Date
      ? new Date(ref.getTime())
      : new Date(`${String(ref).slice(0, 10)}T12:00:00`)
  if (Number.isNaN(base.getTime())) {
    return new Date()
  }

  const opt = rec?.dia_vencimento
  if (opt === 'DATA_VENCIMENTO' && rec?.data_vencimento) {
    const parsed = parseDataApi(rec.data_vencimento)
    if (parsed) return parsed
  }

  const y = base.getFullYear()
  const m = base.getMonth()
  let day = base.getDate()

  switch (opt) {
    case 'PRIMEIRO_DIA_MES':
      day = 1
      break
    case 'ULTIMO_DIA_MES':
      day = new Date(y, m + 1, 0).getDate()
      break
    case 'DIA_5':
      day = 5
      break
    case 'DIA_10':
      day = 10
      break
    case 'DIA_15':
      day = 15
      break
    default:
      break
  }

  const maxDia = new Date(y, m + 1, 0).getDate()
  return new Date(y, m, Math.min(day, maxDia))
}

export function formatarDiaVencimentoRecorrente(date) {
  if (date == null || date === '') return '—'
  const d = date instanceof Date ? date : new Date(date)
  if (Number.isNaN(d.getTime())) return '—'
  return `dia ${String(d.getDate()).padStart(2, '0')} de cada mês`
}

/** Atualiza estado do formulário ao escolher o dia no calendário. */
export function payloadDiaVencimentoRecorrente(date) {
  if (!date) return {}
  const d = date instanceof Date ? date : new Date(date)
  if (Number.isNaN(d.getTime())) return {}

  return {
    dataDiaVencimentoRecorrencia: d,
    vencimento: d,
    diaVencimentoRecorrencia: {
      value: 'DATA_VENCIMENTO',
      label: formatarDiaVencimentoRecorrente(d),
    },
  }
}

export const RECORRENCIA_DEFAULTS = {
  tipoFrequenciaRecorrencia: 'MENSAL',
  periodicidade: { value: 'MENSAL', label: 'Todo mês (mensal)' },
  dataDiaVencimentoRecorrencia: null,
  diaVencimentoRecorrencia: { value: 'DATA_VENCIMENTO', label: 'Dia de vencimento' },
  terminoRecorrencia: { value: 'POR_OCORRENCIAS', label: 'Por número de ocorrências' },
  quantidade: 12,
  repetir: true,
  frequencia: { value: 'MENSAL', label: 'Mensalmente' },
  dataLancamentoRecorrencia: null,
  repetirAnualmente: { value: 'NAO', label: 'Não — repetir todo mês neste dia' },
  diasSemanaRecorrencia: [],
  diasMesRecorrencia: [],
  dataTerminoRecorrencia: null,
}

export const RECORRENCIA_DEFAULTS_DATA_ESPECIFICA = {
  tipoFrequenciaRecorrencia: 'DATA_ESPECIFICA',
  periodicidade: { value: 'DATA_FIXA', label: 'Na data informada' },
  repetirAnualmente: { value: 'NAO', label: 'Não — repetir todo mês neste dia' },
  terminoRecorrencia: { value: 'POR_OCORRENCIAS', label: 'Por número de ocorrências' },
  quantidade: 12,
  repetir: true,
  frequencia: { value: 'MENSAL', label: 'Mensalmente' },
}

export function getDefaultsPorTipoFrequencia(tipo, dataReferencia = new Date()) {
  if (tipo === 'DATA_ESPECIFICA') {
    return {
      ...RECORRENCIA_DEFAULTS_DATA_ESPECIFICA,
      dataLancamentoRecorrencia: dataReferencia,
    }
  }
  if (tipo === 'DIAS_SEMANA') {
    return {
      ...RECORRENCIA_DEFAULTS,
      tipoFrequenciaRecorrencia: 'DIAS_SEMANA',
      periodicidade: { value: 'SEMANAL', label: 'Semanalmente' },
      frequencia: { value: 'SEMANAL', label: 'Semanalmente' },
      diasSemanaRecorrencia: [],
    }
  }
  if (tipo === 'DIAS_MES') {
    return {
      ...RECORRENCIA_DEFAULTS,
      tipoFrequenciaRecorrencia: 'DIAS_MES',
      periodicidade: { value: 'DIA_FIXO_MES', label: 'Em dia fixo do mês' },
      frequencia: { value: 'MENSAL', label: 'Mensalmente' },
      terminoRecorrencia: { value: 'ATE_DATA', label: 'Até uma data' },
      dataTerminoRecorrencia: dataReferencia,
      diasMesRecorrencia: [],
      repetir: false,
    }
  }
  const dataVenc = diaVencimentoApiParaData(
    { dia_vencimento: 'MESMO_DIA_COMPETENCIA', data_vencimento: null },
    dataReferencia
  )

  return {
    ...RECORRENCIA_DEFAULTS,
    tipoFrequenciaRecorrencia: 'MENSAL',
    ...payloadDiaVencimentoRecorrente(dataVenc),
  }
}

export function normalizarDiasSemana(dias) {
  if (!Array.isArray(dias)) return []
  return dias.filter((d) => DIAS_SEMANA_OPCOES.some((op) => op.value === d))
}

export function formatarDiasSemanaLabel(dias) {
  const list = normalizarDiasSemana(dias)
  if (list.length === 0) return ''
  return DIAS_SEMANA_OPCOES.filter((op) => list.includes(op.value))
    .map((op) => op.label)
    .join(', ')
}

export function temDiasSemanaSelecionados(dias) {
  return normalizarDiasSemana(dias).length > 0
}

export function normalizarDiasMes(dias) {
  if (!Array.isArray(dias)) return []
  const valid = new Set(DIAS_MES_OPCOES.map((op) => op.value))
  return dias
    .filter((d) => valid.has(String(d)))
    .sort((a, b) => {
      if (a === 'ULTIMO') return 1
      if (b === 'ULTIMO') return -1
      return Number(a) - Number(b)
    })
}

export function formatarDiasMesLabel(dias) {
  const list = normalizarDiasMes(dias)
  if (list.length === 0) return ''
  return list
    .map((d) => (d === 'ULTIMO' ? 'último' : d))
    .join(', ')
}

export function temDiasMesSelecionados(dias) {
  return normalizarDiasMes(dias).length > 0
}

export function getTerminoOpcoesPorTipo(tipoFrequencia) {
  if (tipoFrequencia === 'DIAS_MES') {
    return [
      { value: 'ATE_DATA', label: 'Até uma data' },
      { value: 'POR_OCORRENCIAS', label: 'Por número de ocorrências' },
      { value: 'SEM_TERMINO', label: 'Sem término (indefinido)' },
    ]
  }
  return TERMINO_OPCOES
}

function formatarDataBr(data) {
  if (data == null || data === '') return '—'
  const d = data instanceof Date ? data : new Date(data)
  if (Number.isNaN(d.getTime())) return '—'
  const dd = String(d.getDate()).padStart(2, '0')
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const yyyy = d.getFullYear()
  return `${dd}/${mm}/${yyyy}`
}

/** Mapeia periodicidade do formulário para frequência legada da API. */
export function periodicidadeParaFrequenciaApi(periodicidade) {
  const v = periodicidade?.value ?? periodicidade
  const map = {
    MENSAL: { value: 'MENSAL', label: 'Mensalmente' },
    BIMESTRAL: { value: 'MENSAL', label: 'Mensalmente' },
    TRIMESTRAL: { value: 'MENSAL', label: 'Mensalmente' },
    SEMESTRAL: { value: 'MENSAL', label: 'Mensalmente' },
    ANUAL: { value: 'ANUAL', label: 'Anualmente' },
    SEMANAL: { value: 'SEMANAL', label: 'Semanalmente' },
    QUINZENAL: { value: 'SEMANAL', label: 'Semanalmente' },
    DATA_FIXA: { value: 'MENSAL', label: 'Mensalmente' },
    DIA_FIXO_MES: { value: 'MENSAL', label: 'Mensalmente' },
  }
  return map[v] ?? { value: 'MENSAL', label: 'Mensalmente' }
}

export function buildResumoRecorrencia(cadastro) {
  const periodicidade =
    cadastro.periodicidade?.label?.toLowerCase() ?? 'todo mês (mensal)'
  const diaVenc = formatarDiaVencimentoRecorrente(
    cadastro.dataDiaVencimentoRecorrencia ??
      cadastro.vencimento ??
      cadastro.competencia
  ).toLowerCase()
  const termino = cadastro.terminoRecorrencia?.value ?? 'POR_OCORRENCIAS'
  const qtd = cadastro.quantidade ?? 12
  const tipoFreq = cadastro.tipoFrequenciaRecorrencia ?? 'MENSAL'

  let partePeriodo = periodicidade
  if (tipoFreq === 'MENSAL') {
    partePeriodo = periodicidade.startsWith('todo') ? periodicidade : `todo ${periodicidade}`
  } else if (tipoFreq === 'DIAS_SEMANA') {
    const diasLabel = formatarDiasSemanaLabel(cadastro.diasSemanaRecorrencia)
    partePeriodo = diasLabel
      ? `nos dias ${diasLabel} da semana`
      : 'nos dias da semana (nenhum selecionado)'
  } else if (tipoFreq === 'DATA_ESPECIFICA') {
    const dataRef =
      cadastro.dataLancamentoRecorrencia ?? cadastro.competencia ?? cadastro.vencimento
    const dataFmt = formatarDataBr(dataRef)
    const repAnual = cadastro.repetirAnualmente?.value === 'SIM'
    const dataParsed = parseDataApi(dataRef)
    const diaMes = dataParsed ? dataParsed.getDate() : null
    partePeriodo = repAnual
      ? `na data ${dataFmt}, repetindo anualmente`
      : diaMes
        ? `todo mês no dia ${String(diaMes).padStart(2, '0')}`
        : `todo mês na data ${dataFmt}`
  } else if (tipoFreq === 'DIAS_MES') {
    const diasLabel = formatarDiasMesLabel(cadastro.diasMesRecorrencia)
    partePeriodo = diasLabel
      ? `todo mês nos dias ${diasLabel}`
      : 'todo mês (nenhum dia selecionado)'
  }

  let parteTermino = ''
  if (termino === 'POR_OCORRENCIAS') {
    parteTermino = `, por ${qtd} ocorrência${Number(qtd) === 1 ? '' : 's'}`
  } else if (termino === 'ATE_DATA') {
    if (tipoFreq === 'DIAS_MES') {
      parteTermino = ', até a data de término'
    } else {
      const dataFmt = formatarDataBr(
        cadastro.dataTerminoRecorrencia ?? cadastro.vencimento ?? cadastro.competencia
      )
      parteTermino =
        dataFmt !== '—' ? `, até ${dataFmt}` : ', até a data de término'
    }
  } else {
    parteTermino = ', sem data de término'
  }

  if (tipoFreq === 'DATA_ESPECIFICA' || tipoFreq === 'DIAS_SEMANA' || tipoFreq === 'DIAS_MES') {
    return `Lançamento ${partePeriodo}${parteTermino}.`
  }

  return `Lançamento ${partePeriodo}, vencimento no ${diaVenc}${parteTermino}.`
}

export function getPeriodicidadeOptions(tipoFrequencia) {
  return PERIODICIDADE_POR_TIPO[tipoFrequencia] ?? PERIODICIDADE_POR_TIPO.MENSAL
}

export const FREQUENCIA_API_OPCOES = [
  { value: 'DIARIO', label: 'Diariamente' },
  { value: 'SEMANAL', label: 'Semanalmente' },
  { value: 'QUINZENAL', label: 'A cada 15 dias' },
  { value: 'MENSAL', label: 'Mensalmente' },
  { value: 'BIMESTRAL', label: 'A cada 2 meses' },
  { value: 'TRIMESTRAL', label: 'A cada 3 meses' },
  { value: 'SEMESTRAL', label: 'A cada 6 meses' },
  { value: 'ANUAL', label: 'Anualmente' },
]

export function opcaoPorValor(opcoes, value) {
  if (value == null || value === '') return null
  const found = (opcoes || []).find((o) => o.value === value)
  return found ?? { value, label: String(value) }
}

/** Converte resposta da API (snake_case) para o estado do formulário. */
export function recorrenciaApiParaCadastro(rec) {
  if (!rec) {
    return { recorrente: false }
  }

  const tipo = rec.tipo_frequencia ?? 'MENSAL'
  const terminoOpts = getTerminoOpcoesPorTipo(tipo)
  const refData =
    parseDataApi(rec.data_lancamento) ??
    parseDataApi(rec.competencia) ??
    parseDataApi(rec.data_vencimento) ??
    new Date()
  const dataDiaVenc =
    tipo === 'MENSAL' ? diaVencimentoApiParaData(rec, refData) : null
  const diaVencPayload =
    tipo === 'MENSAL' && dataDiaVenc ? payloadDiaVencimentoRecorrente(dataDiaVenc) : {}

  return {
    recorrente: Number(rec.recorrente ?? 1) === 1,
    tipoFrequenciaRecorrencia: tipo,
    periodicidade: opcaoPorValor(getPeriodicidadeOptions(tipo), rec.periodicidade),
    ...diaVencPayload,
    terminoRecorrencia: opcaoPorValor(terminoOpts, rec.termino_tipo),
    frequencia: opcaoPorValor(FREQUENCIA_API_OPCOES, rec.frequencia),
    repetir: Number(rec.repetir ?? 0) === 1,
    quantidade: rec.quantidade ?? 12,
    dataLancamentoRecorrencia: parseDataApi(rec.data_lancamento),
    repetirAnualmente: opcaoPorValor(
      REPETIR_ANUALMENTE_OPCOES,
      Number(rec.repetir_anualmente ?? 0) === 1 ? 'SIM' : 'NAO'
    ),
    diasSemanaRecorrencia: Array.isArray(rec.dias_semana) ? rec.dias_semana : [],
    diasMesRecorrencia: Array.isArray(rec.dias_mes) ? rec.dias_mes : [],
    dataTerminoRecorrencia: parseDataApi(rec.data_termino),
  }
}

/** Converte estado do formulário para o payload da API (snake_case). */
export function recorrenciaCadastroParaApi(cadastro) {
  const asYmd = (v) => {
    if (v == null || v === '') return null
    const d = v instanceof Date ? v : new Date(v)
    if (!(d instanceof Date) || Number.isNaN(d.getTime())) return null
    try {
      return d.toISOString().slice(0, 10)
    } catch {
      return null
    }
  }

  if (!cadastro?.recorrente) {
    return { recorrente: false }
  }

  const tipo = cadastro.tipoFrequenciaRecorrencia ?? 'MENSAL'
  const repAnual = cadastro.repetirAnualmente?.value ?? cadastro.repetirAnualmente

  return {
    recorrente: true,
    tipo_frequencia: tipo,
    periodicidade: cadastro.periodicidade?.value ?? cadastro.periodicidade ?? null,
    dia_vencimento:
      tipo === 'MENSAL'
        ? 'DATA_VENCIMENTO'
        : (cadastro.diaVencimentoRecorrencia?.value ?? cadastro.dia_vencimento ?? null),
    termino_tipo:
      cadastro.terminoRecorrencia?.value ?? cadastro.termino_tipo ?? 'POR_OCORRENCIAS',
    frequencia: cadastro.frequencia?.value ?? cadastro.frequencia ?? null,
    repetir: cadastro.repetir ? 1 : 0,
    quantidade: cadastro.quantidade ?? null,
    data_lancamento: asYmd(
      cadastro.dataLancamentoRecorrencia ?? cadastro.competencia ?? cadastro.vencimento
    ),
    repetir_anualmente: repAnual === 'SIM' || repAnual === true ? 1 : 0,
    dias_semana: cadastro.diasSemanaRecorrencia ?? [],
    dias_mes: cadastro.diasMesRecorrencia ?? [],
    data_termino: asYmd(cadastro.dataTerminoRecorrencia),
  }
}
